<app-breadcrumb [master]="'Rejestracje'" [parentName]="'KRK'" [name]="'Lista'"></app-breadcrumb>
<div class="krk-list-container">
  <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm" class="krk-list-filters">
    <app-datepicker
      class="krk-list-filter"
      label="Data utworzenia od"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.gte$createdAt" name="gte$createdAt"
    ></app-datepicker>

    <app-datepicker
      class="krk-list-filter"
      label="Data utworzenia do"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.lte$createdAt" name="lte$createdAt"
    ></app-datepicker>

    <app-dict-ofwcas
      [multiple]="false" label="OFWCA"
      class="krk-list-filter krk-list-filter-long"
      [(ngModel)]="initialFilters.ofwca" name="ofwca"
    ></app-dict-ofwcas>

    <app-dict
      *ngIf="!pendingStatusId" [multiple]="false"
      [dictType]="'krk_status'" [label]="'Status'"
      class="krk-list-filter"
      [(ngModel)]="initialFilters.status" name="status"
    ></app-dict>

    <app-datepicker
      class="krk-list-filter"
      label="Data ważności od"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.gte$activeTo" name="gte$activeTo"
    ></app-datepicker>

    <app-datepicker
      class="krk-list-filter"
      label="Data ważności do"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.lte$activeTo" name="lte$activeTo"
    ></app-datepicker>

    <app-datepicker
      class="krk-list-filter"
      label="Data wyrobienia od"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.gte$activeFrom" name="gte$activeFrom"
    ></app-datepicker>

    <app-datepicker
      class="krk-list-filter"
      label="Data wyrobienia do"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.lte$activeFrom" name="lte$activeFrom"
    ></app-datepicker>

    <app-dict
      [multiple]="false" [dictType]="'krk_payer'"
      [label]="'Kto ponosi opłatę'" class="krk-list-filter"
      [(ngModel)]="initialFilters.payer" name="payer"
    ></app-dict>

    <app-dict-partners
      [multiple]="false" label="Partner"
      class="krk-list-filter"
      [(ngModel)]="initialFilters.partner" name="partner"
    ></app-dict-partners>

    <app-dict-regionals
      [multiple]="false" [label]="'Regionalny (majątek) OFWCA'"
      class="krk-list-filter"
      [(ngModel)]="initialFilters.ofwcaAssetsRegional" name="ofwcaAssetsRegional"
    ></app-dict-regionals>

    <mat-form-field appearance="standard" class="krk-list-filter">
      <mat-label>Aktywna opłata </mat-label>
      <mat-select [(ngModel)]="initialFilters.activeFee" name="activeFee">
        <mat-option [value]="null">Wszystkie</mat-option>
        <mat-option [value]="1">Tak</mat-option>
        <mat-option [value]="0">Nie</mat-option>
      </mat-select>
    </mat-form-field>

  </form>

  <div class="krk-list-buttons">
    <button *ngIf="(userPermissions | async).krk.read_report" (click)="downloadReport()" [disabled]="!(userPermissions | async).krk.read_report"
            mat-raised-button class="report-button"><mat-icon>download</mat-icon> <span> Pobierz raport</span></button>
    <button (click)="filter()" mat-raised-button color="primary"><mat-icon>search</mat-icon> <span> Szukaj</span></button>
    <button (click)="resetFilters()" mat-raised-button color="warn"><mat-icon>delete</mat-icon> <span> Resetuj filtry</span></button>
  </div>

  <table mat-table [dataSource]="krks">

    <!-- Position Column -->
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef> Nazwa </th>
      <td mat-cell *matCellDef="let element">
        <a class="default-link" [routerLink]="['/krk/szczegoly', element.uuid]">KRK {{element.ofwca.fullName}}</a>
      </td>
    </ng-container>

    <ng-container matColumnDef="ofwca">
      <th mat-header-cell *matHeaderCellDef> OFWCA </th>
      <td mat-cell *matCellDef="let element">
        <a class="default-link" [routerLink]="['/ofwca/szczegoly', element.ofwca?.uuid]">{{element.ofwca.fullName}}</a>
      </td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef> Status </th>
      <td mat-cell *matCellDef="let element">
        <button mat-raised-button [ngClass]="element.status.color + '-button'">{{element.status.name}}</button>
      </td>
    </ng-container>

    <ng-container matColumnDef="activeTo">
      <th mat-header-cell *matHeaderCellDef> Data ważności </th>
      <td mat-cell *matCellDef="let element">
        {{element.activeTo | date:'y-MM-dd'}}
      </td>
    </ng-container>

    <ng-container matColumnDef="daysLeft">
      <th mat-header-cell *matHeaderCellDef> Pozostało dni </th>
      <td mat-cell *matCellDef="let element">
        {{element.daysLeft}}
      </td>
    </ng-container>

    <ng-container matColumnDef="payer">
      <th mat-header-cell *matHeaderCellDef> Kto ponosi opłatę </th>
      <td mat-cell *matCellDef="let element">
        {{element.payer?.name}}
      </td>
    </ng-container>


    <ng-container matColumnDef="activeFee">
      <th mat-header-cell *matHeaderCellDef>  Aktywna opłata </th>
      <td mat-cell *matCellDef="let element">
        <mat-slide-toggle
          [disabled]="!(userPermissions | async).krk.write || updateInProgress"
          [checked]="element.activeFee" (change)="agreedToDeregisterChanged(
            $event,
            element
        )"></mat-slide-toggle>
      </td>
    </ng-container>

    <ng-container matColumnDef="partner">
      <th mat-header-cell *matHeaderCellDef> Partner </th>
      <td mat-cell *matCellDef="let element">
        <a class="default-link" [routerLink]="['/partnerzy/szczegoly', element.ofwca?.partner?.uuid]">{{element.ofwca?.partner?.shortName}}</a>
      </td>
    </ng-container>

    <ng-container matColumnDef="assetsRegional">
      <th mat-header-cell *matHeaderCellDef> Regionalny (majątek) OFWCA </th>
      <td mat-cell *matCellDef="let element">
        {{element.ofwca?.assetsRegional?.fullName}}
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <button mat-icon-button [matMenuTriggerFor]="menu"><mat-icon>expand_more</mat-icon></button>
        <mat-menu #menu="matMenu" xPosition="before">
          <button [disabled]="!(userPermissions | async).document.write" mat-menu-item (click)="addDocument(element)">Dodaj dokument</button>
          <button [disabled]="!(userPermissions | async).krk.delete" mat-menu-item (click)="deleteKrk(element)">Usuń</button>
        </mat-menu>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator #paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
</div>
